'use strict';

var _ = require('lodash');
var simpleHepConfig = require('../config/configuration-parameters-simpleHep.json');
var ConfigurationParametersNavigationController = function ConfigurationParametersNavigationController($scope, dataProvider, featureToggleService) {
  function makeDefaultHierarchySelection() {
    $scope.selected.hierarchy = $scope.data[0].hierarchies[0].key;
    $scope.selected.type = $scope.data[0].type;
  }
  $scope.initializeComplexHepNavigation = function () {
    $scope.selected = {};
    dataProvider.getMetadata($scope.configType).then(function (data) {
      data = _.sortBy(data, 'label');
      $scope.data = data;
      makeDefaultHierarchySelection();
      $scope.render();
    });
  };
  $scope.initializeSimpleHepNavigation = function () {
    $scope.selected = {};
    $scope.data = filterSimpleHepType();
    if (!_.isEmpty($scope.data)) {
      $scope.setSimpleHepSelectionParams($scope.data[0].key);
      $scope.render();
    }
  };
  function filterSimpleHepType() {
    var APP_NAME_TO_TYPE_MAPPING = {
      'Revenue Optimizer': 'REVENUE_OPTIMIZER',
      'Fares Optimizer': 'FARES_OPTIMIZER',
      'Dynamic Availability': 'DYNAMIC_AVAILABILITY',
      'Basic Parameters': 'SIMPLE_HEP'
    };
    var dataList = _.cloneDeep(simpleHepConfig);
    dataList = _.filter(dataList, function (data) {
      return featureToggleService.isEnabled(APP_NAME_TO_TYPE_MAPPING[data.key]);
    });
    return dataList;
  }
  $scope.initializeNavigation = function (newConfigType) {
    if (newConfigType === 'SIMPLE_HEP') {
      $scope.initializeSimpleHepNavigation();
    } else {
      $scope.initializeComplexHepNavigation();
    }
  };
  function setHierarchyIsSelectedProperty(hierarchy, type) {
    var transform = function transform(result, value) {
      value.isSelected = value.key === hierarchy && hep.type === type;
    };
    for (var i = 0; i < $scope.data.length; i++) {
      var hep = $scope.data[i];
      _.transform(hep.hierarchies, transform);
    }
  }
  function setIsSelectedPropertySimpleHep(type) {
    for (var i = 0; i < $scope.data.length; i++) {
      $scope.data[i].isSelected = $scope.data[i].key === type;
    }
  }
  $scope.setHierarchySelectionParams = function (hierarchy, type) {
    $scope.selected = {
      hierarchy: hierarchy,
      type: type
    };
    setHierarchyIsSelectedProperty(hierarchy, type);
    $scope.render();
  };
  $scope.setSimpleHepSelectionParams = function (type) {
    $scope.selected = {
      hierarchy: type
    };
    setIsSelectedPropertySimpleHep(type);
  };
  $scope.updateSimpleHepSelectionParams = function (type) {
    $scope.selected = {
      hierarchy: type
    };
    setIsSelectedPropertySimpleHep(type);
    $scope.render();
  };
  $scope.updateHepSelection = function (hierarchy, type) {
    if ($scope.isSimpleHep()) {
      $scope.updateSimpleHepSelectionParams(hierarchy);
    } else {
      $scope.setHierarchySelectionParams(hierarchy, type);
    }
  };
  function toggleSelectedRowCollapseOthers(type) {
    _.transform($scope.data, function (result, value) {
      if (value.type === type) {
        value.isExpanded = !value.isExpanded;
        if (value.isExpanded) {
          $scope.setHierarchySelectionParams(value.hierarchies[0].key, value.type);
        }
      } else {
        value.isExpanded = false;
      }
    });
  }
  $scope.collapseHandler = function (selectedType) {
    toggleSelectedRowCollapseOthers(selectedType);
    $scope.render();
  };
  $scope.isSimpleHep = function () {
    return $scope.configType === 'SIMPLE_HEP';
  };
};
ConfigurationParametersNavigationController.$inject = ['$scope', 'ConfigurationParametersAdvancedDataProviderService', 'FeatureToggleService'];
module.exports = ConfigurationParametersNavigationController;